'use client';

import { LazyLottie } from '../LazyLottie';
import { IAnimationProps } from '../types';

/**
 * -----------------------------------------------------------------------------
 * Renders a Lottie animation for the showing flashing camera icon.
 */
export function PermissionsToCameraAnimation(props: IAnimationProps) {
  const loadAnimation = () =>
    import('../raw-json/functional-assessment/permissions-to-use-camera.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="PermissionsToCameraAnimation"
    />
  );
}
